import FolhaPrevia from "../../components/folha-pagamento/previa/FolhaPrevia";

export default function () {
  return <FolhaPrevia />;
}
